import React from 'react';
import { getAvatarColor } from '../../utils/avatar';
import { getDisplayName } from '../../utils/admin';
import { useBackClose } from '../../utils/backStack';
import { Icon } from '../Icon';

const timeAgo = (ts) => {
    const diff = Date.now() - new Date(ts).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 1) return '방금';
    if (m < 60) return `${m}분 전`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}시간 전`;
    const d = Math.floor(h / 24);
    if (d < 7) return `${d}일 전`;
    return new Date(ts).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
};

// @[userId|닉네임] → @닉네임, 마크다운 기호 제거
const cleanPreview = (text) => {
    if (!text) return '';
    return text
        .replace(/@\[([^|]+)\|([^\]]+)\]/g, '@$2')
        .replace(/[*_`~>#-]/g, '')
        .trim();
};

const channelLabel = (n) => {
    const name = n.channel_name || String(n.channel_id || '');
    return name.startsWith('_private_') ? '개인 대화' : `# ${name}`;
};

// 받은 멘션 모음 (색은 style.css 디자인 토큰을 따른다 — 예전엔 라이트/다크 색을 여기에 직접 적었다)
export function NotificationPanel({ notifications, onClose, onNavigate, onMarkAllRead }) {
    useBackClose(true, onClose);
    const unreadCount = notifications.filter(n => !n.is_read).length;

    return (
        <>
            <div className="mention-backdrop" onClick={onClose} />
            <div className="mention-panel" role="dialog" aria-label="받은 멘션">
                <div className="mention-panel-head">
                    <div className="mention-panel-title">
                        <Icon name="at" size={18} />
                        <b>받은 멘션</b>
                        {unreadCount > 0 && <span className="mention-count">{unreadCount}</span>}
                    </div>
                    {unreadCount > 0 && <button className="mention-read-all" onClick={onMarkAllRead}>모두 읽음</button>}
                    <button className="nav-icon-btn" onClick={onClose} aria-label="닫기"><Icon name="x" /></button>
                </div>
                <div className="mention-list">
                    {notifications.length === 0 ? (
                        <div className="mention-empty">
                            <Icon name="bellOff" size={36} />
                            받은 멘션이 없습니다
                        </div>
                    ) : notifications.map(n => (
                        <button key={n.id} className={`mention-item${n.is_read ? '' : ' unread'}`} onClick={() => onNavigate(n.channel_id, n.message_id)}>
                            <span className="mention-avatar" style={{ background: getAvatarColor(n.sender_username) }}>
                                {getDisplayName(n.sender_username).charAt(0).toUpperCase()}
                            </span>
                            <span className="mention-body">
                                <span className="mention-meta">
                                    <b>{getDisplayName(n.sender_username)}</b>
                                    {(n.channel_name || n.channel_id) && <span className="mention-channel">{channelLabel(n)}</span>}
                                    <time dateTime={n.timestamp}>{timeAgo(n.timestamp)}</time>
                                </span>
                                <span className="mention-preview">{cleanPreview(n.message_preview)}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
}
